module.exports = __webpack_public_path__ + "static/img/repast_1.4e7a9074.jpg";